import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter} from 'react-router-dom'
import BCS from './pages/BCS';

import './sass/bcs.css';


// this is a change for the purpose of a deploy test

ReactDOM.render(
    <BrowserRouter>
        <BCS/>
    </BrowserRouter>
, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js